import {
  getRequest,
  postRequest,
  PutRequest,
  postRequestFormData,
  PatchRequest,
  deleteRequest,
} from "../coreFIles/helper";
import { seedRoundPostRequest, seedRoundGetRequest } from "../coreFIles/seedRoundHelper";

export const adminLogin = async (data) => {
  const res = await postRequest("auth/login", data);
  return res.data;
};

// Second factor for an admin who already has an authenticator enrolled.
export const adminVerifyMfa = async (data) => {
  const res = await postRequest("auth/verifyMfa", data);
  return res.data;
};

// Confirms the QR handed back by the login step on first sign-in.
export const adminSetupMfa = async (data) => {
  const res = await postRequest("auth/setupMfa", data);
  return res.data;
};

export const adminForgotPassword = async (data) => {
  const res = await postRequest("auth/forgotPassword", data);
  return res.data;
};

export const adminResetPassword = async (data) => {
  const res = await postRequest("auth/resetPassword", data);
  return res.data;
};

export const adminChangePassword = async (data) => {
  const res = await PutRequest("changePassword", data);
  return res.data;
};

export const getUserList = async (data) => {
  const res = await getRequest("user/getAllUsers", data);
  return res.data;
};


export const getUserListById = async (id) => {
  const res = await getRequest(`user/getUserById/${id.toString()}`);
  return res.data;
};

export const getSettingsDetails = async (data) => {
  const res = await getRequest('settings/getSettingsDetails', data)
  return res.data
}

export const getCountryListAction = async () => {
  const res = await getRequest("getCountryList");
  return res.data;
};

/*------------------Referral List Start----------------------*/
export const getAllReferalListAction = async (id) => {
  const res = await getRequest(`referral/getAllReferral/${id}`);
  return res.data;
}

export const updateReferralDetails = async (data, id) => {
  const res = await PutRequest(`referral/updateRefferalDetails/${id}`, data)
  return res.data;
}

export const UpdateSetting = async (data) => {
  const res = await postRequest(`settings/updateSettings`, data)
  return res.data
}

export const GetSettingDetails = async () => {
  const res = await getRequest(`settings/getSettingsDetails`)
  return res.data
}

export const getContactAction = async () => {
  const res = await getRequest(`setting/getContactUs`)
  return res.data
}




/*------------------Referral List End----------------------*/

/*------------------Admin Profile Start----------------------*/

export const GetAdminProfileDetails = async () => {
  const res = await getRequest("auth/getProfile")
  return res.data
}

export const updateAdminProfile = async (data) => {
  const res = await postRequestFormData("auth/profileUpdate", data)
  return res.data
}

/*------------------Admin Profile End----------------------*/


export const getDashboardStatisticsAction = async (data) => {
  const res = await getRequest("dashboard", data);
  return res.data;
}

export const changePasswordAction = async (data) => {
  const res = await postRequest("auth/changePassword", data);
  return res.data;
};

//-------------------------------|| SPV APIS ||--------------------------------

export const createSPV = async (data) => {
  const res = await postRequestFormData("spv/createSpv", data)
  return res.data
}

export const getAllUserList = async () => {
  const res = await getRequest("user/getAllUserList")
  return res.data
}



export const updateSPV = async (id, data) => {
  const res = await postRequestFormData(`spv/updateSpv/${id}`, data)
  return res.data
}

export const blockSpv = async (id) => {
  const res = await getRequest(`spv/blockSpv/${id}`)
  return res.data
}

export const updateSpvPublishStatus = async (id, data) => {
  const res = await postRequest(`spv/updateSpvPublishStatus/${id}`, data)
  return res.data
}

export const getActiveSpv = async (data) => {
  const res = await getRequest(`spv/getActiveSpvs`, data)
  return res.data
}

export const getAllNonAssignedSpv = async (data) => {
  const res = await getRequest(`spv/getAllNonAssignedSpv`, data)
  return res.data
}

export const updateDocumentHashStatus=async(data)=>{
  const res=await postRequest(`request/documentHashStatus`,data)
  return res.data
}

//-------------------------------|| PROPERTY APIS ||--------------------------------

export const getAllPropertyList = async () => {
  const res = await getRequest("property/getAllProperties")
  return res.data
}

export const createProperty = async (data) => {
  const res = await postRequestFormData("property/addProperty", data)
  return res.data
}

export const getPropertyDetailById = async (id) => {
  const res = await getRequest(`property/getProperty/${id}`)
  return res.data
}

export const blockProperty = async (id) => {
  const res = await getRequest(`property/activeProperty/${id}`)
  return res.data
}

export const updateProperty = async (id, data) => {
  const res = await postRequestFormData(`property/updateProperty/${id}`, data)
  return res.data
}

export const updatePropertyStatus = async (id, data) => {
  const res = await postRequest(`property/updatePropertyStatus/${id}`, data)
  return res.data
}

/*------------------Tenant APIS Start----------------------*/

export const getAllUsersList = async (id, data) => {
  const res = await getRequest(`users/getAllUsers/${id}`, data)
  return res.data
}

export const getUserDetailsById = async (id, data) => {
  const res = await getRequest(`users/userDetails/${id}`, data)
  return res.data
}

export const getInvestorDetailsById=async(id,data)=>{
  const res=await getRequest(`users/getInvestorDetails/${id}`,data)
  return res.data
}

export const getTenantDetailsById=async(id,data)=>{
  const res=await getRequest(`users/getTenantDetails/${id}`,data)
  return res.data
}

export const blockUser = async (id, data) => {
  const res = await postRequest(`users/blockUsers/${id}`, data)
  return res.data
}

export const tenantRequest = async (data) => {
  const res = await getRequest(`request/getAllTenant`, data)
  return res.data
}

export const updateTenantStatus = async (id, data) => {
  const res = await postRequest(`request/updateTenantStatus/${id}`, data)
  return res.data
}

export const getAllApproveRequest = async (data) => {
  const res = await getRequest('request/getAllApproveUser', data)
  return res.data
}

export const rentStartAction = async (data) => {
  const res = await postRequest('request/startRent', data)
  return res.data
}

export const getAllInvoiceDetail = async (data) => {
  const res = await getRequest('invoice/getAllInvoicesList', data)
  return res.data
}

export const updateInvoice = async (data) => {
  const res = await postRequest('invoice/updateInvoiceStatus', data)
  return res.data
}

/*------------------Tenant APIS End----------------------*/

/*------------------Investor APIS Start----------------------*/
export const getAllInvestorsList = async (data) => {
  const res = await getRequest('investor/investorProperty', data)
  return res.data
}

export const getResaleInvestorProperty = async (data) => {
  const res = await getRequest('investor/getResaleInvestorProperty', data)
  return res.data
}

export const updateInvestorProperty=async(id,data)=>{
  const res=await postRequest(`property/updatePropertyTransaction/${id}`,data)
  return res.data
}
/*------------------Investor APIS End----------------------*/



/*------------------Contact Us APIS Start----------------------*/

export const getAllContactRequest = async (data) => {
  const res = await getRequest('cms/getAllContactUs', data)
  return res.data
}

export const deleteContactUsAction = async (data) => {
  const res = await deleteRequest(`cms/deleteContactUs/${data.id}`)
  return res.data
}

export const getArchivedContactRequest = async (data) => {
  const res = await getRequest('cms/getArchivedContactUs', data)
  return res.data
}

export const archiveContactUsAction = async (data) => {
  const res = await postRequest(`cms/archiveContactUs/${data.id}`, {})
  return res.data
}
export const getAllEmailInsights = async (data) => {
  const res = await getRequest('cms/getAllEmailInsights', data)
  return res.data
}
export const getAllEarlyAllocationAction = async (data) => {
  const res = await getRequest('cms/getAllEarlyAllocation', data)
  return res.data
}

/*------------------Seed Round APIS Start----------------------*/

export const getSeedRoundStatusAction = async (data = {}) => {
  const res = await seedRoundGetRequest("status", data);
  return res.data;
};

export const openSeedRoundAction = async (data = {}) => {
  const res = await seedRoundPostRequest("open", data);
  return res.data;
};

export const closeSeedRoundAction = async (data = {}) => {
  const res = await seedRoundPostRequest("close", data);
  return res.data;
};

export const exportSeedRoundAction = async (data = {}) => {
  const res = await seedRoundPostRequest("export", data);
  return res.data;
};

export const reconcileSeedRoundAction = async (data = {}) => {
  const res = await seedRoundPostRequest("reconcile", data);
  return res.data;
};

/*------------------Seed Round APIS End----------------------*/

/*------------------Aman APIS End----------------------*/


export const userStatusAction = async (data) => {
  const res = await postRequest('user/block-unblock', data)
  return res.data
}

export const getUserById = async (id) => {
  const res = await getRequest(`user/${id}`)
  return res.data
}

export const getAllUserKycList = async () => {
  const res = await getRequest("userKyc/getAllUserKyc")
  return res.data
}

export const userKycStatusAction = async (data) => {
  const res = await postRequest('userKyc/approve-reject', data)
  return res.data
}

export const userWhiteListStatusAction = async (data) => {
  const res = await postRequest('presaleUsers/approve-reject', data)
  return res.data
}


export const getUserKycById = async (id) => {
  const res = await getRequest(`userKyc/${id}`)
  return res.data
}

export const getAllUserTransactionList = async () => {
  const res = await getRequest(`userTransaction/getAllTransactions`)
  return res.data
}


export const getSettingAction = async () => {
  const res = await getRequest(`setting/getAllSetting`)
  return res.data
}

export const updateSettingAction = async (data) => {
  const res = await postRequest('setting/updateSetting', data)
  return res.data
}

export const getAllWhiteList = async () => {
  const res = await getRequest("presaleUsers/getAllWhiteListusers")
  return res.data
}

export const getUniqueWalletTransactionAction = async () => {
  const res = await getRequest("userTransaction/getUniqueWalletTransaction")
  return res.data
}

export const getAllCms = async () => {
  const res = await getRequest("cms/getAllCms")
  return res.data
}

export const updateCms = async (data) => {
  const res = await postRequest('cms/updateCms', data)
  return res.data
}

export const getAllFaqList = async () => {
  const res = await getRequest("faq/getAllFaq")
  return res.data
}

export const createFaqAction = async (data) => {
  const res = await postRequest("faq/addFaq", data)
  return res.data
}

export const updateFaqAction = async (data) => {
  const res = await postRequest("faq/updateFaq", data)
  return res.data
}

export const deleteFaqAction = async (data) => {
  const res = await deleteRequest(`faq/deleteFaq/${data._id}`)
  return res.data
}
